import { render, staticRenderFns } from "./AddToExistingProject.vue?vue&type=template&id=47c4a038"
import script from "./AddToExistingProject.vue?vue&type=script&lang=js"
export * from "./AddToExistingProject.vue?vue&type=script&lang=js"
import style0 from "./AddToExistingProject.vue?vue&type=style&index=0&id=47c4a038&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports